export var sizeStyle = {
  md: {
    height: '24px',
    font: 'var(--text-xs-bold)',
    iconSize: 'xs',
    innerSpacing: 'var(--size-spacing-01)'
  },
  lg: {
    height: '32px',
    font: 'var(--text-sm-bold)',
    iconSize: 'sm',
    innerSpacing: 'var(--size-spacing-02)'
  },
  xl: {
    height: '40px',
    font: 'var(--text-md-bold)',
    iconSize: 'md',
    innerSpacing: 'var(--size-spacing-02)'
  }
};
export var kindStyle = {
  "default": {
    background: 'var(--color-gray-10)',
    color: 'var(--color-gray-100)',
    fill: 'var(--color-gray-60)'
  },
  primary: {
    background: 'var(--color-primary-10)',
    color: 'var(--color-primary-70)',
    fill: 'var(--color-primary-40)'
  },
  success: {
    background: 'var(--color-green-10)',
    color: 'var(--color-green-70)',
    fill: 'var(--color-green-50)'
  },
  danger: {
    background: 'var(--color-red-10)',
    color: 'var(--color-red-70)',
    fill: 'var(--color-red-40)'
  },
  warning: {
    background: 'var(--color-yellow-20)',
    color: 'var(--color-yellow-90)',
    fill: 'var(--color-yellow-70)'
  },
  help: {
    background: 'var(--color-purple-10)',
    color: 'var(--color-purple-70)',
    fill: 'var(--color-purple-40)'
  }
};